<template>
	<div class="ss-content setting-content">
		<div class="ss-container">
			<div class="setting-content__left">
				<div class="user-info">
					<img :src="userInfo.headImage | imgUrl" />
					<p class="username">{{userInfo.username}}</p>
				</div>
				<ul class="menu-list">
					<li v-for="(item, index) in menuList" :key="index" :class="{active: menuIndex === index}" @click="handleMenuClick(item)">
						<span>{{item.label}}</span>
					</li>
				</ul>
			</div>
			<div class="setting-content__right">
				<!-- uni-app 中每个页面是独立的，不再使用 router-view -->
			</div>
		</div>
		
	</div>
</template>

<script>
	import { mapActions } from 'vuex'
	export default {
		data() {
			return {
				userInfo: {},
			menuList: [
				{
					exp: ['signIn'],
					value: 'signIn',
					label: '签到得积分',
					url: '/pages/setting/signIn'
				},
				{
					exp: ['settingActivity'],
					value: 'settingActivity',
					label: '已报名活动',
					url: '/pages/setting/activity'
				},
				{
					exp: ['settingMine'],
					value: 'settingMine',
					label: '个人设置',
					url: '/pages/setting/mine'
				},
				{
					exp: ['settingSafe'],
					value: 'settingSafe',
					label: '安全设置',
					url: '/pages/setting/safe'
				},
				{
					exp: ['settingNotice', 'settingNoticeDetail'],
					value: 'settingNotice',
					label: '系统消息',
					url: '/pages/setting/notice'
				},
				{
					exp: ['settingCollection'],
					value: 'settingCollection',
					label: '我的收藏',
					url: '/pages/setting/collection'
				},
				{
					exp: ['feedback'],
					value: 'feedback',
					label: '意见反馈',
					url: '/pages/feedback/index'
				}
			],
				menuIndex: 0
			}
		},
		onShow() {
			// uni-app 页面显示时，根据当前页面路径更新激活菜单
			const pages = getCurrentPages();
			const currentPage = pages[pages.length - 1];
			if (currentPage && currentPage.route) {
				const routeName = this.getRouteNameFromPath(currentPage.route);
				this.menuIndex = this.menuList.findIndex(o => o.exp.findIndex(o1 => o1 === routeName) !== -1);
			}
		},
		created (){
			this.getUserInfo();
			// 初始化时设置当前激活菜单
			this.updateActiveMenu();
		},
		methods: {
			...mapActions('user', ['GetUserInfoHandle']),
			async getUserInfo() {
				this.userInfo = await this.GetUserInfoHandle(false);
			},
			/**
			 * 处理菜单点击事件，使用 uni.navigateTo 跳转
			 * @param {Object} item - 菜单项对象
			 */
			handleMenuClick(item) {
				if (!item.url) {
					console.warn('菜单项缺少 url 配置:', item);
					return;
				}
				uni.navigateTo({
					url: item.url,
					success: () => {
						// 跳转成功后更新激活菜单
						this.menuIndex = this.menuList.findIndex(o => o.value === item.value);
					},
					fail: (err) => {
						console.error('页面跳转失败:', err);
						uni.showToast({
							title: '页面跳转失败',
							icon: 'none'
						});
					}
				});
			},
			/**
			 * 根据路径获取路由名称
			 * @param {String} path - 页面路径
			 * @returns {String} 路由名称
			 */
			getRouteNameFromPath(path) {
				// 将路径转换为路由名称，例如: /pages/setting/mine -> settingMine
				const pathMap = {
					'pages/setting/signIn': 'signIn',
					'pages/setting/activity': 'settingActivity',
					'pages/setting/mine': 'settingMine',
					'pages/setting/safe': 'settingSafe',
					'pages/setting/notice': 'settingNotice',
					'pages/setting/noticeDetail': 'settingNoticeDetail',
					'pages/setting/collection': 'settingCollection',
					'pages/feedback/index': 'feedback'
				};
				return pathMap[path] || '';
			},
			/**
			 * 更新当前激活的菜单项
			 */
			updateActiveMenu() {
				const pages = getCurrentPages();
				if (pages && pages.length > 0) {
					const currentPage = pages[pages.length - 1];
					if (currentPage && currentPage.route) {
						const routeName = this.getRouteNameFromPath(currentPage.route);
						const index = this.menuList.findIndex(o => o.exp.findIndex(o1 => o1 === routeName) !== -1);
						if (index !== -1) {
							this.menuIndex = index;
						}
					}
				}
			}
		}
	}
</script>

<style lang="scss">
	.setting-content{
		padding-bottom: 135px;
		.ss-container{
			min-height: 980px;
		}
		.setting-content__right{
			position: relative;
			background-color: #fff;
			border: 1px solid #DDDDDD;
			width: 900px;
			float: right;
			min-height: 980px;
			.right-navigation-box{
				position: absolute;
				bottom: -70px;
				left: -208px;
				right: 0;
			}
			.setting-top-box{
				padding: 30px 35px;
				border-bottom: 1px solid #DDDDDD;
				.setting-top-title{
					font-size: 30px;
					font-weight: 400;
					color: #1A6FFE;
					line-height: 30px;
					height: 30px;
					display: inline-block;
					padding-left: 24px;
					border-left: 4px solid #1A6FFE;
				}
			}
		}
		.setting-content__left{
			width: 300px;
			float: left;
			background-color: #fff;
			.menu-list{
				border: 1px solid #DDDDDD;
				border-right: 0;
				padding: 26px 0;
				height: 754px;
				li{
					position: relative;
					text-align: center;
					font-size: 18px;
					font-weight: 400;
					color: #484848;
					line-height: 55px;
					cursor: pointer;
					height: 55px;
					span{
						display: block;
					}
					& + li{
						margin-bottom: 8px;
					}
					&::after{
						content: '';
						width: 8px;
						background: #1A6FFE;
						border-radius: 0px 3px 3px 0px;
						@include abs(0, null, 0, 0);
						@include tst();
						opacity: 0;
					}
					&.active{
						color: #1A6FFE;
						&::after {
							opacity: 1;
						}
					}
				}
			}
			.user-info{
				width: 300px;
				height: 226px;
				background: #1A6FFE;
				padding-top: 30px;
				img{
					width: 110px;
					height: 110px;
					display: block;
					margin: 0 auto;
					border-radius: 100%;
				}
				.username{
					font-size: 18px;
					font-weight: 400;
					color: #FFFFFF;
					line-height: 18px;
					margin-top: 10px;
					text-align: center;
				}
			}
		}
	}
</style>
